import { getCountryFlag } from '@home/_config/countries';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import React, { useMemo } from 'react';

interface IUseRenderOptionNameProps {
  options: any[];
  searchKeywords?: string;
  showCountryFlag?: boolean;
}

function useRenderOptionName(props: IUseRenderOptionNameProps) {
  const { searchKeywords, options, showCountryFlag = true } = props;

  const { locale } = useIntlExtend();

  const renderOptionName = (name: string, code: string) => {
    // if (!highlightSearchKeywords) return name;
    if (!searchKeywords?.trim()?.length) return name;

    // 单选、并且 当前option就是选中项时，不高亮
    // if (value?.type === TYPES_MAPPING.SINGLE && value?.countries?.[0] === code) return name;

    const searchKeywordsChars = searchKeywords?.split('')?.filter((item) => item);
    const reg = new RegExp(searchKeywordsChars?.join('|'), 'ig');
    return name?.replace(reg, (item) => `<span class="dbi-country-highlight">${item}</span>`);
  };

  const optionsPlus = useMemo(() => {
    if (!Array.isArray(options)) return [];
    return options?.map((option) => {
      const countryCode = option?.value ?? '';
      const countryName = option?.text ?? '';
      return {
        ...option,
        name: countryName,
        text: (
          <div className="dbi-filter-selector-option-node">
            {showCountryFlag && (
              <img
                className="dbi-filter-selector-option-node-icon"
                src={getCountryFlag(countryCode)}
                alt=""
              />
            )}
            <span
              className="dbi-filter-selector-option-node-text"
              dangerouslySetInnerHTML={{
                __html: renderOptionName(countryName as string, countryCode),
              }}
            />
          </div>
        ),
      };
    });
  }, [locale, options, searchKeywords]);

  return optionsPlus;
}

export default useRenderOptionName;
